var modules_a3dacc96 = {"list":"_1i5tdnz","ordered":"_n95x04 _1i5tdnz","item":"_12lids1","unordered":"_1aapc77 _1i5tdnz","with-icon":"_jv22v5","icon":"_f1kc1d"};
import "../../../assets/DpZR3mmC.css";

export { modules_a3dacc96 as default };
//# sourceMappingURL=List.module.less.js.map
